var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-unavailable"},[_c('div',{staticClass:"chart-unavailable__block"},[_vm._v(" "+_vm._s(_vm.gaitline ? _vm.$t('commons.sentences.gait-line-not-compatible') : _vm.$t('commons.sentences.chart-not-compatible'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }